import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from 'vuex-module-decorators'
import store from '@/store'

export interface SelectParam {
  query: Number
}

@Module({ dynamic: true, store, name: 'app' })
class Select extends VuexModule implements SelectParam {
  public query = 0

  @Mutation
  private SET_QUERY(query: number) {
    this.query = query
  }

  @Action
  public async GeneratorQuery(query: number) {
    this.SET_QUERY(query)
  }
}

export const SelectModule = getModule(Select)
